import { render, staticRenderFns } from "./HistoricoAulas.vue?vue&type=template&id=184a6547&scoped=true"
import script from "./HistoricoAulas.vue?vue&type=script&lang=js"
export * from "./HistoricoAulas.vue?vue&type=script&lang=js"
import style0 from "./HistoricoAulas.vue?vue&type=style&index=0&id=184a6547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a6547",
  null
  
)

export default component.exports